const visitRoleColors = {
  "super-admin": "rgba(204,168,41,0.1)",
  "local-admin": "rgba(86,71,102,0.1)",
  cmo: "rgba(236,145,216,0.1)",
  doctor: "rgba(12,98,145,0.1)",
  staff: "rgba(204,41,54,0.1)",
  patient: "rgba(171,41,204,0.1)",
  robot: "rgba(114,13,25,0.1)",
  guest: "rgba(73,86,169,0.1)",
  admin: "rgba(58,163,176,0.1)",
};

const visitBorderColors = {
  "super-admin": "rgb(204,168,41)",
  "local-admin": "rgb(86,71,102)",
  cmo: "rgb(236,145,216)",
  doctor: "rgb(12,98,145)",
  staff: "rgb(204,41,54)",
  patient: "rgb(171,41,204)",
  robot: "rgb(114,13,25)",
  guest: "rgb(73,86,169)",
  admin: "#3AA3B0",
};

export const getVisitRoleColors = (role: string) => {
  const roleColor = role as keyof typeof visitRoleColors;

  return visitRoleColors[roleColor] ?? visitRoleColors.guest;
};

export const getVisitBorderColors = (role: string) => {
  const roleColor = role as keyof typeof visitBorderColors;

  return visitBorderColors[roleColor] ?? visitBorderColors.guest;
};
